const re = /^\?/;

export function sanitizeQueryString (queryString) {
    return queryString.replace(re, '');
}
